/*
 * <sis-photo-reviews> (blocks/sis-photo-reviews.liquid): prev/next arrows for
 * the customer photo row. Each click scrolls by one photo; an arrow hides at
 * its end of the row, and both hide when every photo fits. The row itself is
 * plain scroll-snap, so swiping works without this script.
 */
class SisPhotoReviews extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector(':scope > .sis-photo-reviews__track');
    this.arrows = [...this.querySelectorAll(':scope > .sis-photo-reviews__arrow')];
    if (!this.track || this.arrows.length !== 2) return;
    this.onClick = (e) => this.step(Number(e.currentTarget.dataset.dir));
    this.update = () => this.refresh();
    this.arrows.forEach((arrow) => arrow.addEventListener('click', this.onClick));
    this.track.addEventListener('scroll', this.update, { passive: true });
    this.resizer = new ResizeObserver(this.update);
    this.resizer.observe(this.track);
    this.onSelect = (e) => {
      const card = e.target.closest?.('.sis-photo-review');
      if (card && this.track.contains(card)) card.scrollIntoView({ block: 'nearest', inline: 'start' });
    };
    document.addEventListener('shopify:block:select', this.onSelect);
    this.refresh();
  }

  disconnectedCallback() {
    this.arrows?.forEach((arrow) => arrow.removeEventListener('click', this.onClick));
    this.track?.removeEventListener('scroll', this.update);
    this.resizer?.disconnect();
    document.removeEventListener('shopify:block:select', this.onSelect);
  }

  get rtl() {
    return getComputedStyle(this).direction === 'rtl';
  }

  step(dir) {
    const card = this.track.firstElementChild;
    const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
    const by = card ? card.getBoundingClientRect().width + gap : this.track.clientWidth;
    this.track.scrollBy({ left: by * dir * (this.rtl ? -1 : 1), behavior: 'smooth' });
  }

  refresh() {
    const { track } = this;
    const max = track.scrollWidth - track.clientWidth;
    const at = Math.abs(track.scrollLeft); // negative in right-to-left pages
    const [prev, next] = this.arrows;
    prev.hidden = next.hidden = max <= 1;
    const focused = this.arrows.find((arrow) => arrow === document.activeElement);
    prev.disabled = at <= 1;
    next.disabled = at >= max - 1;
    // a disabled arrow is hidden: hand keyboard focus to the other one
    if (focused?.disabled) this.arrows.find((arrow) => !arrow.disabled && !arrow.hidden)?.focus();
  }
}

if (!customElements.get('sis-photo-reviews')) customElements.define('sis-photo-reviews', SisPhotoReviews);
